<template>
    <div class="setRent_formation_box">
        <div class="inform_tit"> 
            <div @click="cancel" class='cancel_box'>
                <i class="el-icon-back myback_icon"></i> Back
            </div>
        </div>
        <div v-if="isPro" class="inMain_box">
            <div class="informdata_tit">Set Rent</div>
            <el-form :model="ruleForm" label-position="top" :hide-required-asterisk="true" :rules="rules" ref="ruleForm" label-width="100px" class="information-ruleForm">
                <el-form-item label="Lease End Date" prop="leaseTime" style="position:relative">
                    <div class="timeshowBox" style="width:170px">{{showTime1}}</div>
                    <el-date-picker
					v-model="ruleForm.leaseTime"
					class="venueInformation_input"
					style="width:100%"
                    :clearable="true"
                    @change="changeTime(1)"
					type="date"
					format="dd/MM/yyyy"
					placeholder="">
					</el-date-picker>
                </el-form-item>
                <el-form-item label="Does the Rental Agreement include outgoings?">
                    <div class="checkBox_list">
                        <div class="venue_checkBox">
                            <span v-if="ruleForm.does== null" @click="ruleForm.does=1" class="venue_check"></span>
                            <span v-if="ruleForm.does==0" @click="ruleForm.does=1" class="venue_check"></span>
                            <span v-else-if="ruleForm.does==1" class="venue_checked"></span>
                            <span class="venueCheckBox_msg">Yes</span>
                        </div>
                        <div class="venue_checkBox">
                            <span v-if="ruleForm.does== null" @click="ruleForm.does=0" class="venue_check"></span>
                            <span v-if="ruleForm.does==1"  @click="ruleForm.does=0" class="venue_check"></span>
                            <span v-else-if="ruleForm.does==0" class="venue_checked"></span>
                            <span class="venueCheckBox_msg">No</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="" :required="false">
                    <!-- <el-input v-model="ruleForm.rental" maxlength="10" class="venueInformation_input increaseInput">
                        <span slot="prefix" class="increaseIcon">$</span>
                    </el-input> -->
                    <div class="checkBox_list">
                        <el-col :span="12" style="margin-right:30px">
                            <el-form-item label="Monthly Rental Cost" prop="rental">
                                <div class="venue_checkBox1 increaseInput">
                                    <el-input v-model="ruleForm.rental" maxlength="10"  @input="changeM" class="venueInformation_input">
                                        <span slot="prefix" class="increaseIcon">$</span>
                                    </el-input>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Annual Rental Cost" prop="rental1">
                                <div class="venue_checkBox1">
                                    <el-input v-model="ruleForm.rental1" maxlength="10" @input="changeY" class="venueInformation_input increaseInput">
                                        <span slot="prefix" class="increaseIcon">$</span>
                                    </el-input>
                                </div>
                            </el-form-item>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="Yearly Rental Increase In % Or $ Value" :required="false">
					 <div class="checkBox_list">
                         <el-col :span="12" style="margin-right:30px">
                        <el-form-item prop="increase1">
                        <!-- <el-form-item prop="increase1" :rules="ruleForm.increaseType==1?[{ required: true, message: ' ', trigger: 'blur' }]:[]" ref="increase1"> -->
                            <div class="venue_checkBox1">
                                <span v-if="ruleForm.increaseType==null" @click="changeIncre(1)" class="venue_check"></span>
                                <span v-if="ruleForm.increaseType==0" @click="changeIncre(1)" class="venue_check"></span>
                                <span v-else-if="ruleForm.increaseType==1" class="venue_checked"></span>
                                <el-input v-model="ruleForm.increase1" maxlength="6" :disabled="ruleForm.increaseType==0" class="venueInformation_input">
                                    <span slot="suffix" class="increaseIcon">%</span>
                                </el-input>
                            </div>
                        </el-form-item>
                         </el-col>
                         <el-col :span="12">
                        <el-form-item prop="increase2">
                        <!-- <el-form-item prop="increase2" :rules="ruleForm.increaseType==0?[{ required: true, message: ' ', trigger: 'blur' }]:[]" ref="increase2"> -->
                            <div class="venue_checkBox1">
                                <span v-if="ruleForm.increaseType==null"  @click="changeIncre(2)" class="venue_check"></span>
                                <span v-if="ruleForm.increaseType==1"  @click="changeIncre(2)" class="venue_check"></span>
                                <span v-else-if="ruleForm.increaseType==0" class="venue_checked"></span>
                                <el-input v-model="ruleForm.increase2" maxlength="10" @blur="increase2Blur" :disabled="ruleForm.increaseType==1" class="venueInformation_input increaseInput">
                                    <span slot="prefix" class="increaseIcon">$</span>
                                </el-input>
                            </div>
                        </el-form-item>
                         </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="Yearly Rental Increase Date" prop="IncreaseTime">
                    <div class="timeshowBox" style="width:100%">
                        <i class="el-icon-date"></i>
                        {{showTime2}}</div>
                    <el-cascader @change="changeTime(2)" class="timeshowBox1" style="z-index:1;width:100%;opacity:0" :options="dateOptions" separator=" " placeholder="" v-model="ruleForm.IncreaseTime"></el-cascader>
                    <!-- <el-date-picker
					v-model="ruleForm.IncreaseTime"
					class="venueInformation_input"
                    @change="changeTime(2)"
					style="width:100%"
					type="date"
					:clearable='true'
					format="dd/MM/yyyy"
					placeholder="">
					</el-date-picker> -->
                </el-form-item>
                <el-form-item label="Rent Free Period" prop="free">
                    <el-input v-model="ruleForm.free" maxlength="10" class="venueInformation_input">
						<span slot="suffix" class="increaseIcon">months</span>
					</el-input>
                </el-form-item>
                <el-form-item label="Additional Amount" prop="amount">
                    <el-input v-model="ruleForm.amount" class="venueInformation_input increaseInput">
						<span slot="prefix" class="increaseIcon">$</span>
					</el-input>
                </el-form-item>
                <el-form-item class="foot_box">
                    <el-button @click="cancel" class="cardCanBtn">Cancel</el-button>
                    <el-button @click="confirm" class="cardConBtn">Confirm</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div v-if="isDoneLoad && !isPro">
            <div class="error-container d-flex align-items-center justify-content-center">
                <card-unauthorized></card-unauthorized>
            </div>
        </div>

        <el-dialog :visible.sync="isTrialEnd" class="peiso-modal" width="810px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
			<free-trial-notice :info="venueDiscountDetailsPojo" :isPro="isPro" @close-notice="closeOrLogoutVenue"></free-trial-notice>
		</el-dialog>
    </div>
</template>

<script>
import api from '../../api/api'
import dateOptions from '../../utils/time'
import cardUnauthorized from '@/components/card/unauthorized';
import freeTrialNotice from '@/components/modal/freeTrialNotice';
export default {
    data() {
        return {
            dateOptions:dateOptions,
            rules:{
                leaseTime:[{ required: false, message: ' ', trigger: 'change' }],
                rental:[{ required: false, message: ' ', trigger: 'blur' }],
                rental1:[{ required: false, message: ' ', trigger: 'blur' }],
                // increase1:[{ required: true, message: ' ', trigger: 'blur' }],
                // increase2:[{ required: true, message: ' ', trigger: 'blur' }],
                IncreaseTime:[{ required: false, message: ' ', trigger: 'change' }],
                // free:[{ required: true, message: ' ', trigger: 'blur' }],
                // amount:[{ required: true, message: ' ', trigger: 'blur' }]
            },
            showTime1:'',
            showTime2:'',
            ruleForm:{
				leaseTime:'',
				// does:1, //单选框默认选中
                does: null,
				rental:'',
				rental1:'',
				// increaseType: null,
				increase1:'',
				increase2:'',
				IncreaseTime:'',
				free:'',
                amount:'',
                er:''
            },
            isPro: false,
            isDoneLoad: false,
            venueDiscountDetailsPojo: null,
      		isTrialEnd: false,
        }
    },
    components: {
        cardUnauthorized: cardUnauthorized,
        freeTrialNotice: freeTrialNotice,
    },
    methods: {
        changeM(){
            this.ruleForm.rental1 = this.ruleForm.rental?(this.ruleForm.rental*12).toFixed(2):0
        },
        changeY(){
            this.ruleForm.rental = this.ruleForm.rental1?(this.ruleForm.rental1/12).toFixed(2):0
        },
        changeIncre(key){
            if(key==1){
                this.$nextTick(()=>{
                    this.ruleForm.increaseType=1;
                    this.ruleForm.increase2='';
                    // this.$refs['increase2'].clearValidate();
                })
            }
            else{
                this.$nextTick(()=>{
                    this.ruleForm.increaseType=0;
                    this.ruleForm.increase1='';
                    // this.$refs['increase1'].clearValidate();
                })
            }
        },
        increase2Blur(){
            this.$refs['ruleForm'].validateField('increase2');
        },
        cancel(){
            this.$router.push({path:'/setting'})
        },
        confirm(){ 
            this.$refs["ruleForm"].validate((valid) => {  
                if (valid) {
                    // if (this.ruleForm.increaseType == null)
                    //     return
                    let pat={
                        leaseEndDate:(this.ruleForm.leaseTime)/1000, //结束日期
                        // yearlyRentalIncreaseType:this.ruleForm.increaseType==1?1:0, //增长类型
                        // yearlyRentalIncrease:this.ruleForm.increaseType==1?this.ruleForm.increase1:this.ruleForm.increase2?this.ruleForm.increase2:0, // 增长幅度
                        // yearlyRentalIncreaseDate:(this.ruleForm.IncreaseTime)/1000, // 增长时间
                        // yearlyRentalIncreaseDate:this.ruleForm.IncreaseTime[0]+ '-' +this.ruleForm.IncreaseTime[1], // 增长时间
                        rentFreePeriod:this.ruleForm.free, //免租期
                        additionalAmount:this.ruleForm.amount, // 额外金额
                        monthlyRentalCost:this.ruleForm.rental, // 月租金
                        yearRentalCost:this.ruleForm.rental1, // 年租金
                        // includeOutgoings:this.ruleForm.does==1?1:0
                    }
                    if (this.ruleForm.IncreaseTime[0])
                        pat.yearlyRentalIncreaseDate = this.ruleForm.IncreaseTime[0]+ '-' +this.ruleForm.IncreaseTime[1]
                    if (this.ruleForm.does !== null)
                        pat.includeOutgoings = this.ruleForm.does==1?1:0
                    if (this.ruleForm.increaseType !== null){
                        pat.yearlyRentalIncreaseType = this.ruleForm.increaseType==1?1:0
                        pat.yearlyRentalIncrease = this.ruleForm.increaseType==1?this.ruleForm.increase1:this.ruleForm.increase2?this.ruleForm.increase2:0 // 增长幅度
                    }
                    api.setRent(pat,res=>{
                        let {code,data,message}=res.data;
                        if(code==0){
                             this.$router.push({path:'/setting'})
                             Utils.alert2('', 'Rent successfully saved', 'success')
                        }else{
                            Utils.alert2('',message,'error')
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        changeTime(key){
            if(key == 1){
                this.ruleForm.leaseTime?this.showTime1=Utils.timestampToTime(this.ruleForm.leaseTime):this.showTime1 = ''
            }else{ // 
                // this.ruleForm.IncreaseTime?this.showTime2=Utils.timestampToTime(this.ruleForm.IncreaseTime):this.showTime2 = ''
                this.getShowTime()
            }
        },
        getShowTime(){
            let M = this.ruleForm.IncreaseTime[0]
            if (M === '01') {
                M = 'Jan'
            } else if (M === '02') {
                M = 'Feb'
            } else if (M === '03') {
                M = 'Mar'
            } else if (M === '04') {
                M = 'Apr'
            } else if (M === '05') {
                M = 'May'
            } else if (M === '06') {
                M = 'Jun'
            } else if (M === '07') {
                M = 'Jul'
            } else if (M === '08') {
                M = 'Aug'
            } else if (M === '09') {
                M = 'Sep'
            } else if (M === '10') {
                M = 'Oct'
            } else if (M === '11') {
                M = 'Nov'
            } else if (M === '12') {
                M = 'Dec'
            }
            this.ruleForm.IncreaseTime?this.showTime2 = this.ruleForm.IncreaseTime[1] + ' ' + M:this.showTime2 = ''
        },
        getdetail(){
            api.getRent({},res=>{
                let {code,data,message}=res.data;
                if(code==0){
                    if (data) {
                        this.ruleForm.leaseTime = Utils.checkValueExists(data.leaseEndDate) ? data.leaseEndDate*1000 : ''
                        this.showTime1 = Utils.timestampToTime(data.leaseEndDate*1000)
                        this.showTime2 = Utils.timestampToTime(data.yearlyRentalIncreaseDate*1000)
                        // this.ruleForm.increaseType=data.yearlyRentalIncreaseType==0?0:1
                        if (Utils.checkValueExists(data.yearlyRentalIncreaseType)) {
                            this.ruleForm.increaseType = data.yearlyRentalIncreaseType
                            if (data.yearlyRentalIncreaseType) {
                                this.ruleForm.increase1 = data.yearlyRentalIncrease
                            } else {
                                this.ruleForm.increase2 = data.yearlyRentalIncrease
                            }
                            
                        }
                        
                        // this.ruleForm.IncreaseTime=data.yearlyRentalIncreaseDate!=null?data.yearlyRentalIncreaseDate*1000:''
                        this.ruleForm.IncreaseTime= Utils.checkValueExists(data.yearlyRentalIncreaseDate) ? data.yearlyRentalIncreaseDate.split('-') : ''
                        this.getShowTime()
                        this.ruleForm.free = Utils.checkValueExists(data.rentFreePeriod) ? data.rentFreePeriod : ''
                        this.ruleForm.amount= Utils.checkValueExists(data.additionalAmount) ? data.additionalAmount : ''
                        this.ruleForm.rental= Utils.checkValueExists(data.monthlyRentalCost) ? data.monthlyRentalCost : ''
                        this.ruleForm.rental1= Utils.checkValueExists(data.yearRentalCost) ? data.yearRentalCost : ''
                        // this.ruleForm.does=data.includeOutgoings==1?1:0
                        this.ruleForm.does= Utils.checkValueExists(data.includeOutgoings) ? data.includeOutgoings : ''
                    }
                }else{
                    Utils.alert('',message,'error')
                }
            })
        },
        closeOrLogoutVenue(isSubscribe) {
			if (isSubscribe) {
				this.isTrialEnd = false
				return
			}
			if (this.venueDiscountDetailsPojo.remainingDays <= 0) {
				this.$root.$emit('logout-venue')
			} else {
				const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
				if (isContUsingTrial == '0') {
				sessionStorage.setItem('isContUsingTrial', '1')
				}
				this.isTrialEnd = false
			}
		}


    },
    mounted() {
        this.getdetail()
        this.$root.$on('isPro', (isPro, others) => { 
            this.isPro = isPro
            this.isDoneLoad = true

            const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
			if (others.venueDiscountDetailsPojo && others.venueDiscountDetailsPojo.remainingDays <= 3 && isContUsingTrial == '0') {
				this.venueDiscountDetailsPojo = others.venueDiscountDetailsPojo
				this.isTrialEnd =  true
			}
        })
    }, 
    computed: {
        nrental(){
            return this.ruleForm.rental
        },
        rental1(){
            return this.ruleForm.rental1
        },
        nincrease1(){
            return this.ruleForm.increase1
        },
        nincrease2(){
            return this.ruleForm.increase2
        },
        nfree(){
            return this.ruleForm.free
        },
        namount(){
            return this.ruleForm.amount
        }
    },
    watch: {
        nrental(n,o){
			if(n != ''){
				let reg = /^\d+(\.\d{0,2})?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.rental = o;
					}, 50);
				}
			}
		},
        rental1(n,o){
			if(n != ''){
				let reg = /^\d+(\.\d{0,2})?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.rental1 = o;
					}, 50);
				}
			}
		},
        nincrease1(n,o){
			if(n != ''){
				let reg = /^\d+(\.\d{0,2})?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.increase1 = o;
					}, 50);
				}
				if(n > 100){
					setTimeout(()=>{
						this.ruleForm.increase1=100
					},50)
				}
			}
        },
        nincrease2(n,o){
			if(n != ''){
				let reg = /^\d+(\.\d{0,2})?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.increase2 = o;
					}, 50);
				}
			}
		},
        nfree(n,o){
			if(n != ''){
                let reg = /^\d+(\d)?$/;
				if (new RegExp(reg).test(n) == false) {
					setTimeout(() => {
					    this.ruleForm.free = o;
					}, 50);
				}
			}
		},
        namount(n,o){
            if(n){
                let reg = /^\d+(\.\d{0,2})?$/;
                if (new RegExp(reg).test(n) == false && n!='') {
                    setTimeout(() => {
                        this.ruleForm.amount = o;
                    }, 100);
                }
            }
		}
    },
}
</script>

<style lang="scss">
    .setRent_formation_box{
        position: relative;
        .inform_tit{
            height:76px;
            font-size:14px;
            font-weight:600;
            color:var(--text-color);
            line-height:20px;
            width: 100%;
            background-color: var(--background-color);
            z-index: 100;
            .cancel_box{
                cursor: pointer;
                width: 150px;
            }
        }
        .inMain_box{
            background-color: var(--background-color-4);
            width: 100%;
            box-sizing: border-box;
            padding:50px 15%;
            margin-bottom: 40px;
            .informdata_tit{
                text-align: center;
                margin-bottom: 50px;
                height:42px;
                font-size:30px;
                font-family:PingFangSC-Semibold,PingFang SC;
                font-weight:600;
                color:var(--text-color);
                line-height:42px;
            }
            .checkBox_list{
                display: flex;
                // height: 40px;
                align-items: center;
            }
            .venue_checkBox{
                display: flex;
                align-items: center;
                margin-right: 319px;
                .venue_check{
                    width:16px;
                    height:16px;
                    box-sizing: border-box;
                    background:rgba(43,52,68,1);
                    border-radius:50%;
                    border:1px solid rgba(95,95,95,1);
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venue_checked{
                    width:16px;
                    height:16px;
                    background: url("../../../static/img/Shape.png");
                    background-size: cover;
                    border-radius:50%;
                    background-repeat: no-repeat;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venueCheckBox_msg{
                    width: 100px;
                    height:28px;
                    font-size:20px;
                    font-family:PingFang SC;
                    font-weight:400;
                    color:var(--text-color);
                    line-height:28px;
                }
            }
            .venue_checkBox1{
                display: flex;
                align-items: center;
				margin-right: 30px;
                width: 100%;
                .venue_check{
                    width:17px;
                    height:16px;
                    box-sizing: border-box;
                    background:rgba(43,52,68,1);
                    border-radius:50%;
                    border:1px solid rgba(95,95,95,1);
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venue_checked{
                    width:17px;
                    height:16px;
                    background: url("../../../static/img/Shape.png");
                    background-size: cover;
                    border-radius:50%;
                    background-repeat: no-repeat;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .venueCheckBox_msg{
                    height:28px;
                    font-size:20px;
                    font-family:PingFang SC;
                    font-weight:400;
                    color:var(--text-color);
                    line-height:28px;
                }
            }
            .venueAddtype_btn{
                width:150px;
                height:40px;
                padding: 10px 20px !important;
                background:rgba(43,52,68,1);
                border:1px solid rgba(209,58,144,1);
                font-size:20px;
                font-weight:400;
                color:rgba(209,58,144,1);
            }
            .venueType_box{
                display: inline-block;
                padding:0 20px;
                height:40px;
                line-height: 40px;
                background:rgba(21,28,39,1);
                border:1px solid rgba(95,95,95,1);
                font-size: 20px;
                color: var(--text-color);
                vertical-align: top;
                box-sizing: border-box;
                margin-left: 30px;
                position: relative;
                border-radius: 4px;
                .myclose_icon{
                    position: absolute;
                    top: -12px;
                    right: -12px;
                    background-color: var(--text-color);
                    color: var(--background-color-4);
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    font-size: 15px;
                    font-weight: 600;
                    line-height: 20px;
                    text-align: center;
                    cursor: pointer;
                }
            }
        }
    }
    .checked{
        color: #D13A90 !important;
	}
	.increaseIcon{
		line-height: 50px;
		font-size: 18px;
		color: var(--text-color);
		&:first-child{
			margin-right: 20px;
		}
		&:last-child{
			margin-left: 20px;
		}
	}
    // .timeshowBox{
    //     position: absolute;
    //     width: 115px;
    //     z-index: 10;
    //     height: 38px;
    //     top:1px;
    //     font-size: 20px;
    //     color: var(--text-color);
    //     left: 30px;
    //     background-color: var(--background-color-3);
    // 
    .timeshowBox{
        position: absolute;
        width: 355px;
        border: 1px solid var(--background-color-4);
        border-radius: 4px;
        z-index: 0;
        height: 38px;
        line-height: 38px;
        top:1px;
        padding-left: 10px;
        font-size: 20px;
        color: var(--text-color);
        left: 0px;
        background-color: var(--background-color-3);
    }
    .timeshowBox1{
        .el-input.is-focus{
            border-color: #565758 !important;
        }
        .el-input__inner{
            width: 100%;
            z-index: 10;
            height: 40px;
            padding-left: 30px !important;
            top:1px;
            font-size: 20px;
            color: var(--text-color);
            padding-left: 15px;
            border: 1px solid #565758;
            border-radius: 4px;
            background-color: var(--background-color-3);
            &:hover{
                border: 1px solid #565758 !important;
            }
            &:focus{
                border: 1px solid #565758 !important;
            }
        }
        .el-input__suffix{
            display: none !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/setting/setrent.vue